import React from 'react';
import l10n from "../../../l10n/localization";
import * as utilsFog from "../../../utils/fog";
import * as utilsCommon from "../../../utils/utils";
import {Button, Input} from "react-materialize";
import * as fogActions from "../../../actions/fog";
import * as documentActions from "../../../actions/documents";
import ListDocuments from "./ListDocuments";
import AdditionalCharges from "./AdditionalCharges";
import AdditionalChargeForm from "../../forms/AdditionalChargeForm";
import * as creationActions from "../../../actions/creation";

export default class Underwriter extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getFog();
        this.oldStateRebateRate = null;
    }

    getFog() {
        return utilsFog.fogToForm(this.props.fogs.getById(this.props.fog.id).original);
    }

    generateDocument(type) {
        this.props.dispatch(documentActions.generateDocuments(this.props.fog.id, type, this.props.displayAll));
    }

    countTypedAdditionnalCharge(invoices, type) {
        let counter = 0;

        for (let i = 0; i < invoices.length; i++) {
            if (invoices[i].document_type === type) {
                counter++;
            }
        }
        return counter
    }

    onVat8UnderwriterCheckboxClick() {
        let newValue = !this.state.vat8Underwriter;
        let form = Object.assign({}, {...utilsFog.fogToForm(this.props.fogs.getById(this.props.fog.id).original), comments: this.state.comments});
        form.vat8Underwriter = newValue;

        this.setState({...this.state, vat8Underwriter: newValue}, this.props.dispatch(fogActions.edit(form, false, this.props.displayAll)));
    }

    submit(obj) {
        this.oldStateRebateRate = this.getFog().rebateRate;

        let form = Object.assign({}, {...obj});

        this.setState({...obj}, () => {
            if (form.overage === undefined || form.overage === null) {
                form.overage = false;
            }
            if (form.brokerageReturn === undefined || form.brokerageReturn === null) {
                form.brokerageReturn = false;
            }

            this.props.dispatch(fogActions.edit(form, false, this.props.displayAll));
        });
    }

    onChangeCheckbox(event) {
        let fogCopy = {...this.getFog(), brokerageReturn: event.target.checked};
        this.submit(fogCopy);
    }

    saveRebateRate(obj) {
        this.submit(obj);
    }

    onKeyPressedRebateRate(event) {
        if (event.key === 'Enter') {
            let fogCopy = {...this.getFog(), rebateRate: parseFloat(event.target.value)};
            this.onChangeRebateRate(event, () => this.props.dispatch(fogActions.edit(fogCopy, false, this.props.displayAll)));
        }
    }

    saveButton = () =>{
        let fakeEvent = { target: { value: null } };
        fakeEvent.target.value = Number(this.refs['input'].value);
        let fogCopy = {...this.getFog(), rebateRate: parseFloat(this.refs['input'].value)};
        this.onChangeRebateRate(fakeEvent, () => this.props.dispatch(fogActions.edit(fogCopy, false, this.props.displayAll)));
    };

    componentDidMount() {
        this.props.underwriterSave(this.saveButton);
    }

    onChangeRebateRate(event, callback = null) {
        let fogCopy = {...this.getFog(), rebateRate: parseFloat(event.target.value)};
        this.setState({...fogCopy}, () => {
            if (fogCopy.overage === undefined || fogCopy.overage === null) {
                fogCopy.overage = false;
            }
            if (fogCopy.brokerageReturn === undefined || fogCopy.brokerageReturn === null) {
                fogCopy.brokerageReturn = false;
            }

            if (utilsCommon.notNullNorUndefined(callback)) {
                callback();
            }
        });
    }

    getUnderwriterRebateRate() {
        return utilsCommon.notNullNorUndefined(this.props.fog.underwriter) ? this.props.fog.underwriter.rebateRate : 0;
    }

    render() {
        let tmp = this.props.fogs.getById(this.props.fog.id)
        let isChecked = {};
        let totalInvoiceUnderwriter = this.props.total.additionalChargesSumTyped['INVOICE_UNDERWRITER'] + this.props.total.underwriter.fogSettlement;

        if (this.getFog().brokerageReturn === true) {
            isChecked = {
                defaultChecked: 'checked',
            }
        }

        return (
            <section style={{marginTop: "100px"}}>
                <h2 className="yellow-border">{l10n.fog.underwriter}</h2>
                <div className="content">
                    <article>
                        <table>
                            <tbody>
                            <tr className="row">
                                <td className="col s5">
                                    <span className="title">{l10n.fog.creditNote}</span>
                                </td>
                                <td className="col s3 right-align">
                                    <span className="total">{l10n.fog.total} {utilsCommon.money(this.props.total.underwriter.total.toFixed(3), this.props.currency)}</span>
                                </td>
                                <td className="col s4" />
                            </tr>
                            <tr className="row">
                                <td className="col s5">
                                    <span>{l10n.fog.underwriterFogsPremium}</span>
                                </td>
                                <td className="col s3 right-align">
                                    <span>{utilsCommon.money(this.props.total.underwriter.fogPremium.toFixed(3), this.props.currency)}</span>
                                </td>
                                <td className="col s4 right-align">
                                    <button className="btn btn-primary full" disabled={this.props.generating} onClick={() => this.generateDocument('CREDIT_NOTE_UNDERWRITER')}>{l10n.common.btnGenerateCreditNote}</button>
                                    <br />
                                    <ListDocuments dispatch={this.props.dispatch} fog={this.props.fog} fogReference={tmp.original.reference} documents={tmp.sortedDocuments['CREDIT_NOTE_UNDERWRITER'] !== undefined ? tmp.sortedDocuments['CREDIT_NOTE_UNDERWRITER'] : []} />
                                </td>
                            </tr>
                            <tr className="row">
                                <td className="col s7">
                                    <span>{l10n.fog.additionalCharges}</span>
                                </td>
                                <td className="col s7">
                                    <AdditionalCharges {...this.props} type='CREDIT_NOTE_UNDERWRITER' />
                                    <i className="left-align">
                                        <Button
                                            style={{marginTop: tmp.original.invoices !== undefined && this.countTypedAdditionnalCharge(tmp.original.invoices, 'CREDIT_NOTE_UNDERWRITER') > 0 ? "-94px" : ""}}
                                            type="button" floating
                                            onClick={() => this.props.openDrawer(AdditionalChargeForm, {
                                                item: null,
                                                fog: this.props.fog,
                                                type: 'CREDIT_NOTE_UNDERWRITER'
                                            }, creationActions.destroyingnewlyCreatedInvoice())} icon="add" className="add-button small"/>
                                    </i>
                                    <span
                                        style={{float: "right"}}>{utilsCommon.money(this.props.total.additionalChargesSumTyped['CREDIT_NOTE_UNDERWRITER'].toFixed(3), this.props.currency)}</span>
                                </td>
                            </tr>
                            {tmp.original.overage && tmp.original.overageClientRate > 0 &&
                                <tr className="row">
                                    <td className="col s5">
                                        <span>{l10n.fog.overageLabel}</span>
                                    </td>
                                    <td className="col s3 right-align">
                                        <span>{utilsCommon.money(this.props.total.underwriter.overage.toFixed(3), this.props.currency)}</span>
                                    </td>
                                    <td className="col s4" />
                                </tr>
                            }
                            </tbody>
                        </table>
                    </article>
                    <article style={{marginTop: "50px"}}>
                        <table>
                            <tbody>
                            <tr className="row">
                                <td className="col s6">
                                    <br />
                                    <span className="title">{l10n.fog.invoice}</span>
                                </td>
                                <td className="col s3" />
                                <td className="col s3" />
                            </tr>
                            <tr className="row">
                                <td className="col s5">
                                    <span>
                                        <Input
                                            type="checkbox"
                                            name={'root_brokerageReturn'}
                                            {...isChecked}
                                            label={l10n.fog.brokerageReturnAsPerAgreement}
                                            onChange={this.onChangeCheckbox.bind(this)}
                                            disabled={this.props.loading}
                                        />
                                    </span>
                                </td>
                                <td className="col s3 right-align">
                                    <span>
                                    <span style={{float: 'left'}}><input ref="input" value={this.state.rebateRate ? this.state.rebateRate : this.getUnderwriterRebateRate()} onBlur={(event) => this.saveRebateRate.bind(this, this.state)} onKeyPress={this.onKeyPressedRebateRate.bind(this)} onChange={this.onChangeRebateRate.bind(this)} style={{width: '60px', height: '30px', marginBottom: 0}} type="number" name="root_rebateRate" />&nbsp;%</span>
                                        {utilsCommon.money(this.props.total.underwriter.brokerageReturn.toFixed(3), this.props.currency)}</span>
                                </td>
                                <td className="col s4 right-align">
                                    <button className="btn btn-primary full" disabled={this.props.generating} onClick={() => this.generateDocument('INVOICE_REBATE_UNDERWRITER')}>{l10n.common.btnGenerateInvoice}</button>
                                    <br />
                                    <ListDocuments dispatch={this.props.dispatch} fog={this.props.fog} fogReference={tmp.original.reference} documents={tmp.sortedDocuments['INVOICE_REBATE_UNDERWRITER'] !== undefined ? tmp.sortedDocuments['INVOICE_REBATE_UNDERWRITER'] : []} />
                                </td>
                            </tr>
                            <tr className="row" style={{marginTop: "80px"}}>
                                <td className="col s5" />
                                <td className="col s3 right-align">
                                    <span
                                        className="total">{l10n.fog.total} {utilsCommon.money(totalInvoiceUnderwriter.toFixed(3), this.props.currency)}</span>
                                </td>
                                <td className="col s3" />
                            </tr>
                            <tr className="row">
                                <td className="col s5">
                                    <span>{l10n.fog.fogSettlement}</span>
                                </td>
                                <td className="col s3 right-align">
                                    <span>{utilsCommon.money(this.props.total.underwriter.fogSettlement.toFixed(3), this.props.currency)}</span>
                                </td>
                                <td className="col s4 right-align">
                                    <button className="btn btn-primary full" disabled={this.props.generating} onClick={() => this.generateDocument('INVOICE_UNDERWRITER')}>{l10n.common.btnGenerateInvoice}</button>
                                    <br />
                                    <ListDocuments dispatch={this.props.dispatch} fog={this.props.fog} fogReference={tmp.original.reference} documents={tmp.sortedDocuments['INVOICE_UNDERWRITER'] !== undefined ? tmp.sortedDocuments['INVOICE_UNDERWRITER'] : []} />
                                </td>
                            </tr>
                            <tr className="row">
                                <td className="col s7">
                                    <span>{l10n.fog.additionalCharges}</span>
                                </td>
                                <td className="col s7">
                                    <AdditionalCharges {...this.props} type='INVOICE_UNDERWRITER' />
                                    <i className="left-align">
                                        <Button
                                            style={{marginTop: tmp.original.invoices !== undefined && this.countTypedAdditionnalCharge(tmp.original.invoices, 'INVOICE_UNDERWRITER') > 0 ? "-94px" : ""}}
                                            type="button" floating
                                            onClick={() => this.props.openDrawer(AdditionalChargeForm, {
                                                item: null,
                                                fog: this.props.fog,
                                                type: 'INVOICE_UNDERWRITER'
                                            }, creationActions.destroyingnewlyCreatedInvoice())} icon="add" className="add-button small"/>
                                    </i>
                                    <span
                                        style={{float: "right"}}>{utilsCommon.money(this.props.total.additionalChargesSumTyped['INVOICE_UNDERWRITER'].toFixed(3), this.props.currency)}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </article>

                    <br />
                    <div className="col s6">
                        <div className="form-group field field-string">
                            <input type="checkbox"
                                   name={'root_vat8Underwriter'}
                                   value={'root_vat8Underwriter'}
                                   checked={this.state.vat8Underwriter}
                                   onChange={() => {}}
                                   disabled={this.props.loading}
                            />
                            <label htmlFor={'root_vat8Underwriter'}
                                   onClick={this.onVat8UnderwriterCheckboxClick.bind(this)}>Underwriter VAT 7.7%</label>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/fog/costInvoice/Underwriter.js